module.exports = "/_next/static/images/Reliability@2x-0b9b07e817ffd7dd9367144d94c22794.webp";